import React from "react"; 
import { useQueryParams } from "../../hooks/useQueryParams";

const PrimaryTabs = ({ tabKey = "tab", tabs = [], className, tabClass }) => {
  const { query, setQueryParam } = useQueryParams();

  const activeValue = query[tabKey] || tabs[0]?.value; 
  
  const handleTabClick = (tab) => {
    if (tab.onClick) {
      tab.onClick();
    } else {
      setQueryParam(tabKey, tab.value);
    }
  };

  return (
    <div className={`flex bg-[#F1F4FB] p-0 rounded-md ${className}`}>
      {tabs.map((tab) => {
        const isActive = activeValue === tab.value;
        return (
          <button
            key={tab.value}
            onClick={() => handleTabClick(tab)}
            className={`px-5 py-3 text-black rounded-t-xl ${
              isActive
                ? "bg-white font-semibold"
                : ""
            } ${tabClass}`}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default PrimaryTabs;
